import { DMPClient } from '../dotnet-client'
import { ENDPOINTS } from '@/util'
import { createContext, useContext, useMemo } from 'react'
import { useSessionStorage } from '@/hooks'

type DotnetClientContext = {
  dmpClient: DMPClient | undefined
  isDMPClientLoaded: boolean
}

const DEFAULT_CONTEXT: DotnetClientContext = {
  dmpClient: undefined,
  isDMPClientLoaded: false,
}

const DotnetClientContext = createContext<DotnetClientContext>(DEFAULT_CONTEXT)

export const DotnetClientProvider = ({ children }: { children: React.ReactNode }) => {
  const [token] = useSessionStorage('token', '')

  const dmpClient = useMemo(() => {
    return new DMPClient({
      BASE: ENDPOINTS.DOTNET,
      TOKEN: token,
    })
  }, [token])

  return (
    <DotnetClientContext.Provider value={{ dmpClient, isDMPClientLoaded: !!dmpClient }}>
      {children}
    </DotnetClientContext.Provider>
  )
}

export const useDotnetClient = () => {
  const context = useContext(DotnetClientContext)
  if (!context) throw new Error('useDotnetClient must be used within a DotnetClientProvider')
  return context
}
